const setRedirectURLs = (url: string) => {
    sessionStorage.setItem('redirectURL', url);
};

export default setRedirectURLs;
